import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-user-roles',
  templateUrl: 'user.roles.component.html'
})

export class UserRolesComponent implements OnInit {

  updateEmitter = new EventEmitter<any>();

  constructor(private aRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
  }

  update() {
    this.updateEmitter.emit('');
  }
  volver() {
      this.router.navigate(['../../'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usersAndProfiles/user-roles/user.roles.component.ts